"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var filters_module_1 = require("./filters.module");
exports.FiltersModule = filters_module_1.FiltersModule;
__export(require("./reducer"));
__export(require("./actions"));
__export(require("./services"));
__export(require("./models"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/index.js
// module id = ../../../../../src/app/packages/menu-items/filters/index.js
// module chunks = main